module.exports = __webpack_public_path__ + "img/mask_ban.d16a595d.png";